/**
 * OAuth Types - Sprint 1b
 *
 * Unified OAuth types for browser and desktop platforms.
 *
 * @see docs/sprints/ownyou-sprint1b-spec.md
 */
/**
 * Token refresh margin (refresh 5 minutes before expiry)
 */
export const TOKEN_REFRESH_MARGIN_MS = 5 * 60 * 1000;
/**
 * Default scopes for Microsoft Graph API
 * Includes Mail.Read + Calendars.Read so a single OAuth consent covers both
 */
export const MICROSOFT_DEFAULT_SCOPES = [
    'offline_access',
    'openid',
    'profile',
    'email',
    'User.Read',
    'Mail.Read',
    'Calendars.Read',
];
/**
 * Default scopes for Google APIs (Gmail + Calendar)
 * Combined scopes so a single OAuth consent covers both email and calendar
 */
export const GOOGLE_DEFAULT_SCOPES = [
    'openid',
    'profile',
    'email',
    'https://www.googleapis.com/auth/gmail.readonly',
    'https://www.googleapis.com/auth/calendar.readonly',
];
//# sourceMappingURL=types.js.map